import { render, staticRenderFns } from "./ReferralView.vue?vue&type=template&id=c0449034&"
import script from "./ReferralView.vue?vue&type=script&lang=js&"
export * from "./ReferralView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports